var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('theme-provider',{staticClass:"ui-h-screen"},[_c('c-preview-bar'),_c('router-view'),_c('c-modal'),_c('c-toast',{staticClass:"ui-fixed ui-mx-auto",attrs:{"id":"toast","auto-position":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }